// extracted by mini-css-extract-plugin
export default {"textRow":"_3Pbh","text":"_24mm"};